import { RootState } from '€slices/types';

/* eslint-disable import/prefer-default-export */
export const timedOut = (state: RootState) => state.auth.sessionTimeout;
export const loadingDashboard = (state: RootState) => state.network.loadingDashboardInit;
